<template>
    <div>
        <form v-on:submit.prevent="login" class="floating-labels mini-login">

            <div class="row">
                <div class="col-12 m-auto">
                    <div class="form-group">
                        <input type="text" class="form-control" id="_username" v-model="username" required=""
                               autocomplete="off"><span class="highlight"></span> <span class="bar"></span>
                        <label for="_username"><i class="icon-user"></i> {{ t.user.username }}</label>
                    </div>
                </div>
                <div class="row">

                </div>
                <div class="col-12 m-auto">
                    <div class="form-group">
                        <input type="password" class="form-control" id="_password" v-model="password" required=""
                               autocomplete="off"><span class="highlight"></span> <span class="bar"></span>
                        <label for="_password"><i class="icon-lock"></i> {{ t.user.password }}</label>
                        <a href="javascript:;" v-on:click="forgotPassword"
                           class="btn btn-sm pull-left col-6 mt-1 text-right">kullanıcı adı / </a>
                        <a href="javascript:;" v-on:click="forgotPassword"
                           class="btn btn-sm pull-left col-6 mt-1 text-left">Şifremi unuttum?</a>
                    </div>
                </div>
                <div class="col-12 m-auto">
                    <div class="row">
                        <button class="login-button col-12" v-on:click="login">{{ t.login }}
                        </button>
                        <!--<router-link :to="{name: 'Register'}" class="btn btn-primary btn-sm pull-left col-12 mt-1">{{
                                                                                                                   t.register
                                                                                                                   }}
                        </router-link>-->
                    </div>
                </div>
            </div>
        </form>

        <sweet-modal ref="fpmodal" width="600">
            <resetting/>
        </sweet-modal>
    </div>
</template>

<script>
    import Resetting from '@/components/user/form/resetting.vue'

    export default {
        name: 'LoginTop',
        components: {Resetting},
        data() {
            return {
                t: this.$parent.t,
                username: null,
                password: null,
                loginError: false,
                blurred: true,
            }
        },
        mounted() {
            this.isLogged();
        },
        methods: {
            isLogged() {
                this.refreshToken = this.$cookie.get('refresh_token');

                var th = this;
                this.$getItem('auth', function (key, value) {
                    ////console.log all the kay/value pairs

                    th.$http.get(api + 'oauth/v2/token',
                        {
                            params: {
                                client_id: value.client, client_secret: value.clientSecret, grant_type: 'refresh_token',
                                refresh_token: value.refreshToken
                            }
                        }).then(
                        response => {

                            window.accessTokenHeader = response.body.access_token;
                            window.auth.accessToken = response.body.access_token;
                            window.auth.refreshToken = response.body.refresh_token;
                            window.auth.client = value.client;
                            window.auth.clientSecret = value.clientSecret;

                            th.$setItem('auth', window.auth);

                        }, response => {

                            th.blurred = false;
                        });

                }, function (err) {

                })
            },
            login() {
                if (this.password && this.username) {
                    this.loginError = false;
                    this.blurred = true;
                    this.$bus.$emit('globalLoader', false);

                    if (typeof window.auth.client === 'undefined')
                        this.$parent.getClient();

                    this.clientId = window.auth.client;
                    this.clientSecret = window.auth.clientSecret;

                    this.$http.get(api + 'oauth/v2/token',
                        {
                            params: {
                                client_id: this.clientId, client_secret: this.clientSecret, grant_type: 'password',
                                username: this.username, password: this.password
                            }
                        }).then(
                        response => {
                            this.$emit('accessToken', {
                                at: response.body.access_token,
                                rt: response.body.refresh_token
                            });
                            window.accessTokenHeader = response.body.access_token;

                            window.auth.accessToken = response.body.access_token;
                            window.auth.refreshToken = response.body.refresh_token;

                            this.$setItem('auth', window.auth);
                            this.blurred = false;
                            this.$bus.$emit('sessionUpdated', true);
                            this.$router.push('/');

                        }, response => {
                            this.loginError = true;
                            this.blurred = false;

                            this.$notify({
                                group: 'app',
                                title: this.t.processing.error,
                                text: this.t.auth.login_error,
                                type: 'error',
                            });

                        });
                    return false;
                }
            },
            forgotPassword() {
                this.$refs.fpmodal.open()
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /* login box */

    a {
        color: #ccc;
        font-size: 9px;
        text-transform: capitalize;
        padding: 0;
    }

    a:hover {
        color: #333;
    }

    .mini-login {
        width: 180px;
        position: absolute;
        right: 55px;
        top: 55px;
        background: #fff;
        padding: 5px;
        box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.4);
    }

    .mini-login:before {
        content: '';
        position: absolute;
        left: 70px;
        top: -10px;
        border-style: solid;
        border-width: 0 15px 10px 15px;;
        border-color: transparent transparent #fff transparent;
    }

    .mini-login .row {
        margin: 0 !important;
    }

    .mini-login .row .col-12 {
        padding: 0;
    }

    .mini-login .login-button {
        width: 100%;
        background: #3c3c3c;
        color: #fff;
        overflow: hidden;
        text-align: center;
        height: 28px;
        border: 0;
        font-size: 14px;
        cursor: pointer;
        border-radius: 0;
    }

    .mini-login .login-button:hover {
        background: #f64835;
    }

    .mini-login .form-control {
        background: none;
        border: 1px solid #ececec;
        height: 30px;
        line-height: 30px;
        font-size: 13px;
        padding: 0;
        padding-left: 10px;
    }

    .mini-login .form-group {
        margin-bottom: 5px;
        cursor: pointer;
        font-size: 14px;
        color: #333;
    }

    .mini-login .bar:after, .floating-labels .bar:before {
        background: #fff;
    }

    .mini-login label {
        color: #333;
        font-size: 13px;
        position: absolute;
        top: 5px;
    }

    .mini-login .form-control:focus ~ label, .floating-labels .form-control:valid ~ label {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/auth/LoginTop.vue